const mockData = [
    { id: '10001', label: 'EVERYDAY', qty: '(668)' },
    { id: '10002', label: 'WINTER', qty: '(573)' },
    { id: '10003', label: 'FALL', qty: '(230)' },
    { id: '10004', label: 'SPRING', qty: '(118)' },
    { id: '10005', label: 'SUMMER', qty: '(57)' }
];

export const defaultAccordionData = [
    { id: '1', label: 'Product Types', data: mockData },
    { id: '2', label: 'Season', data: mockData },
    { id: '3', label: 'Branded & Licensed Collections', data: mockData },
    { id: '4', label: 'Themes', data: mockData },
    { id: '5', label: 'Holidays', data: mockData },
    { id: '6', label: 'Prices', data: mockData },
    { id: '7', label: 'Size', data: mockData },
    { id: '8', label: 'Features', data: mockData },
    { id: '9', label: 'Collection', data: mockData },
    { id: '10', label: 'Materials', data: mockData },
    { id: '11', label: 'Merchandising', data: mockData },
    { id: '12', label: 'Color', data: mockData },
    { id: '13', label: 'Program', data: mockData },
    { id: '14', label: 'Sale Tag', data: mockData }
];

export const productCardData = {
    src: '/en/glass-dragonfly-with-iron-feet-set-of-3-p-phl065/?item_list_id=Category&amp;item_list_name=D%C3%A9cor&amp;index=1',
    imageSrc:
        '/globalassets/product-images/phl065.jpg?width=360&amp;height=360&amp;bgColor=white',
    flags: ['New', 'Best Seller'],
    brand: 'Plow & Hearth',
    name: 'Glass Dragonfly With Iron Feet Set of 3',
    price: '$72.50 USD',
    sku: 'SKU PHL065',
    availability: 'Ships Within 60 Days',
    qty: 2,
    step: 2,
    isInWishlist: false
};

export const defaultSortingOptions = [
    {
        display_name: 'Relevance',
        sort_by: 'relevance',
        sort_order: 'descending'
    },
    {
        display_name: 'Best Sellers',
        sort_by: 'BestSellers',
        sort_order: 'descending'
    },
    {
        display_name: 'New',
        sort_by: 'NewestFirst',
        sort_order: 'descending'
    },
    {
        display_name: 'Price (Low to High)',
        sort_by: 'price',
        sort_order: 'ascending'
    },
    {
        display_name: 'Price (High to Low)',
        sort_by: 'price',
        sort_order: 'descending'
    }
];

export const defaultLimiterOptions = [
    {
        display_name: '48',
        data: '48'
    },
    {
        display_name: '72',
        data: '72'
    },
    {
        display_name: '96',
        data: '96'
    }
];

export const defaultAvailabilityOptions = [
    { value: 'now', display_name: 'Now', count: 1216 },
    { value: 'within15days', display_name: 'Within 15 Days', count: 88 },
    { value: 'within60days', display_name: 'Within 60 Days', count: 87 },
    { value: 'after60days', display_name: 'After 60 Days', count: 366 }
];
